import React, { useMemo } from 'react'
import { ContactContainer, TextContainer } from '@/styles/pages/contact'
import { useTranslation } from 'react-i18next'

import Public from '@/helpers/PageTypes/Public'

import SEO from '@/components/SEO'
import HeaderUnsigned from '@/components/LandingPage/Header'
import FooterUnsigned from '@/components/LandingPageV2/Shared/Footer'
import EmailButton from '@/components/EmailButton'
import { ContactForm } from '@/components/ContactForm'

import { ASSET_PATHS } from '@/services/paths'

import { ContactFormProvider } from '@/contexts/ContactFormContext'

const Contact = () => {
  const { t } = useTranslation()

  const whatsAppLink = useMemo(
    () => `https://wa.me/${t('labels.contactWhats').replace(/\D/g, '')}`,
    [t]
  )

  return (
    <ContactFormProvider>
      <Public>
        <SEO title={` | ${t('titles.contact')}`} />
        <HeaderUnsigned pageName="contact" />
        <ContactContainer>
          <TextContainer>
            <h1>{t('subtitles.sales')}</h1>
            <a
              href={whatsAppLink}
              target="_blank"
              rel="noopener noreferrer"
              id="btn_whatsapp"
              className="flexbox v-centered"
            >
              <img
                src={ASSET_PATHS.icon_whatsapp}
                alt=""
                className="material-icons"
              />
              <span className="contact">{t('labels.contactWhats')}</span>
            </a>
            <EmailButton id="contacts" iconOutline={false} />
          </TextContainer>
          <ContactForm />
        </ContactContainer>
        <FooterUnsigned />
      </Public>
    </ContactFormProvider>
  )
}

export default Contact
